var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "saved-payments" }, [
    _c(
      "div",
      { staticClass: "saved-payments__wrapper" },
      _vm._l(_vm.payments, function(payment) {
        return _c(
          "label",
          {
            key: payment.token,
            staticClass: "saved-payments__item",
            class: {
              "saved-payments__item--active": _vm.value == payment.token,
              "saved-payments__item--disabled": payment.disabled,
              "saved-payments__item--readonly": _vm.readonly,
              "saved-payments__item--error": _vm.error
            }
          },
          [
            _c("input", {
              staticClass: "saved-payments__item-radio",
              attrs: {
                type: "radio",
                name: "saved-payments",
                disabled:
                  payment.disabled ||
                  (_vm.readonly && _vm.value != payment.token)
              },
              domProps: {
                value: payment.token,
                checked: _vm.value == payment.token
              },
              on: { change: _vm.onInput }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "saved-payments__item-title",
              domProps: { innerHTML: _vm._s(payment.paymentMethodTitle) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "saved-payments__item-content" }, [
              payment.image
                ? _c("img", {
                    staticClass: "saved-payments__item-image",
                    attrs: { src: payment.image }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", {
                staticClass: "saved-payments__item-name",
                domProps: { innerHTML: _vm._s(payment.name) }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "saved-payments__item-checkbox" })
            ]),
            _vm._v(" "),
            _c("Button", {
              attrs: {
                type: "button",
                level: "tertiary",
                text: "löschen",
                arrow: ""
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.onDelete(payment)
                }
              }
            })
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.hint
      ? _c("span", {
          staticClass: "form-input__hint | form-input-hint",
          domProps: { innerHTML: _vm._s(_vm.hint) }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.error && _vm.errorMessage
      ? _c("span", {
          staticClass: "form-input__error | form-input-error",
          domProps: { innerHTML: _vm._s(_vm.errorMessage) }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.successMessage
      ? _c("span", {
          staticClass: "form-input__success | form-input-success",
          domProps: { innerHTML: _vm._s(_vm.successMessage) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }